import HttpError from '../../common/models/HttpError';
import MylemonadeScopes from '../../common/models/MyLemonadeScopes';

export default class CustomerErrors {
    static CUSTOMER_NOT_FOUND_IN_ORDER: HttpError = new HttpError("CUSTOMER_NOT_FOUND_IN_ORDER", "The customer is not found in the order", 400, MylemonadeScopes.CUSTOMERS);
    static NO_CUSTOMER_RECEIVED: HttpError = new HttpError("NO_CUSTOMER_RECEIVED", "No customer received", 400, MylemonadeScopes.CUSTOMERS);
}